import { render, staticRenderFns } from "./content-top.vue?vue&type=template&id=6e4834d2&lang=pug&"
import script from "./content-top.vue?vue&type=script&lang=js&"
export * from "./content-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports